/*  
  TODO: TO BE DEPRECATED: This file doesn't seem to be in use anymore for Flights team.
  If packages team doesn't use this, we can remove it
*/
import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Box, getPaletteColor, Text, Flex, Absolute, Relative } from 'pcln-design-system'
import { getBrandAttributeInclusion } from '../Itinerary/helpers'
import ShelfOption from './ShelfOption'

const TierBoxWrapper = styled(Flex)`
  ${(props) => (props.tier === 3 ? 'display: none' : '')};
  ${(props) => props.theme.flyQueries.tabletlg} {
    ${(props) =>
      props.shelfVariantName === 'THREESHELVES' ? 'width: 33.33% !important; display: flex !important;' : ''}
  }
`

const EmptyOption = styled(Relative)`
  border: solid ${getPaletteColor('border.base')} 1px;
  border-left-width: ${(props) => (props.borderLeft ? '1px' : '0px')};
  cursor: auto;
`

const getPriceObject = (priceString) => {
  const priceArray = priceString.split('.')
  return {
    dollar: priceArray[0],
    cents: priceArray[1],
  }
}

const getRoundCorner = (shelfVariantName, tier) => {
  if (shelfVariantName === 'THREESHELVES') {
    return tier === 3
  }
  return tier === 2
}

const TierBox = ({ upsell, tier, handleClick, shelfVariantName }) => {
  const roundCorner = getRoundCorner(shelfVariantName, tier)
  return (
    <TierBoxWrapper width={1 / 2} tier={tier} shelfVariantName={shelfVariantName}>
      {upsell.status === 'available' && (
        <ShelfOption
          key={tier}
          token={upsell.token}
          fareBrandName={upsell.name}
          carryOnAvailability={getBrandAttributeInclusion(upsell.brandAttributes, 'CARRY_ON')}
          seatAvailability={getBrandAttributeInclusion(upsell.brandAttributes, 'SEATS')}
          checkedBagAvailability={getBrandAttributeInclusion(upsell.brandAttributes, 'CHECKED_BAG')}
          price={getPriceObject(upsell.price)}
          borderLeft={tier === 1}
          borderRadiusOverride={roundCorner ? 'xl' : null}
          handleClick={handleClick}
        />
      )}
      {upsell.status === 'sold_out' && (
        <EmptyOption
          roundCorner={roundCorner}
          width={'100%'}
          borderLeft={tier === 1}
          borderRadius={roundCorner ? 'xl' : 'none'}
          rounded='topRight'
        >
          <Absolute mb={'20px'} width={'100%'} top={0} left={0} p={2}>
            <Text align='center' caps bold fontSize={'10px'} lineHeight={'12px'}>
              {upsell.expectedName}
            </Text>
          </Absolute>
          <Box pt={'25%'}>
            <Text fontSize={0} align='center' color='text.light'>
              Sold Out
            </Text>
          </Box>
        </EmptyOption>
      )}
      {upsell.status === 'not_offered' && (
        <EmptyOption
          roundCorner={roundCorner}
          width={'100%'}
          borderLeft={tier === 1}
          borderRadius={roundCorner ? 'xl' : 'none'}
          rounded='topRight'
        >
          <Box pt={'25%'}>
            <Text fontSize={0} align='center' color='text.light'>
              Not Available
            </Text>
          </Box>
        </EmptyOption>
      )}
    </TierBoxWrapper>
  )
}

TierBox.propTypes = {
  upsell: PropTypes.shape({
    status: PropTypes.string,
    price: PropTypes.object,
    name: PropTypes.string,
    carryOn: PropTypes.string,
    seat: PropTypes.string,
    checkedBag: PropTypes.string,
    token: PropTypes.string,
    expectedName: PropTypes.string,
    brandAttributes: PropTypes.array,
  }),
  tier: PropTypes.number,
  handleClick: PropTypes.func,
  shelfVariantName: PropTypes.string,
}

export default TierBox
